import {
  CostFilterDto,
  CostSummaryDto,
  CostBreakdownRow,
} from '../Model/CostType';
import { callService } from '../../../Service/ServiceBase';
import { RequestType } from '../../../Service/RequestType';

// ─── DUMMY DATA — remove this and uncomment the real callService below ────────
/*
const DUMMY: CostSummaryDto = {
  TotalCost: 57760.66,
  LastPeriodCost: 218757.32,
  Delta: -160996.67,
  DeltaPercent: -73.6,
  UntaggedCost: 41962.96,
  FetchedAt: '2026-03-09T14:32:39.889Z',

  TopTenants: [
    {
      Tenant: 'online58cc36ff_pool_1',
      Cost: 2766.5,
      LastPeriodCost: 527.53,
      AllocatedSharedCost: 0,
      TotalCost: 2766.5,
      Delta: 2238.96,
      DeltaPercent: 424.4,
      Scope: 'Dedicated',
      Farms: ['48'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'technipfmc',
      Cost: 4820.44,
      LastPeriodCost: 6100.2,
      AllocatedSharedCost: 0,
      TotalCost: 4820.44,
      Delta: -1279.76,
      DeltaPercent: -21.0,
      Scope: 'Dedicated',
      Farms: ['48', '50'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'archer',
      Cost: 3950.12,
      LastPeriodCost: 4500.0,
      AllocatedSharedCost: 0,
      TotalCost: 3950.12,
      Delta: -549.88,
      DeltaPercent: -12.2,
      Scope: 'Dedicated',
      Farms: ['48'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
  ],

  TenantSummary: [
    {
      Tenant: 'online58cc36ff_pool_1',
      Cost: 2766.5,
      LastPeriodCost: 527.53,
      AllocatedSharedCost: 0,
      TotalCost: 2766.5,
      Delta: 2238.96,
      DeltaPercent: 424.4,
      Scope: 'Dedicated',
      Farms: ['48'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'technipfmc',
      Cost: 4820.44,
      LastPeriodCost: 6100.2,
      AllocatedSharedCost: 0,
      TotalCost: 4820.44,
      Delta: -1279.76,
      DeltaPercent: -21.0,
      Scope: 'Dedicated',
      Farms: ['48', '50'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'archer',
      Cost: 3950.12,
      LastPeriodCost: 4500.0,
      AllocatedSharedCost: 0,
      TotalCost: 3950.12,
      Delta: -549.88,
      DeltaPercent: -12.2,
      Scope: 'Dedicated',
      Farms: ['48'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'nov',
      Cost: 3210.8,
      LastPeriodCost: 5800.0,
      AllocatedSharedCost: 0,
      TotalCost: 3210.8,
      Delta: -2589.2,
      DeltaPercent: -44.6,
      Scope: 'Dedicated',
      Farms: ['50'],
      Regions: ['norwayeast', 'westeurope'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'halliburton',
      Cost: 2100.33,
      LastPeriodCost: 2900.0,
      AllocatedSharedCost: 0,
      TotalCost: 2100.33,
      Delta: -799.67,
      DeltaPercent: -27.6,
      Scope: 'PlanShared',
      Farms: ['189'],
      Regions: ['norwayeast'],
      Environment: 'Dev',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'schlumberger',
      Cost: 1880.0,
      LastPeriodCost: 3100.5,
      AllocatedSharedCost: 0,
      TotalCost: 1880.0,
      Delta: -1220.5,
      DeltaPercent: -39.4,
      Scope: 'PlanShared',
      Farms: ['190'],
      Regions: ['norwayeast'],
      Environment: 'Dev',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'equinor',
      Cost: 5540.2,
      LastPeriodCost: 48000.0,
      AllocatedSharedCost: 0,
      TotalCost: 5540.2,
      Delta: -42459.8,
      DeltaPercent: -88.5,
      Scope: 'Dedicated',
      Farms: ['48', '50'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: 'aker-bp',
      Cost: 1320.44,
      LastPeriodCost: 1800.0,
      AllocatedSharedCost: 0,
      TotalCost: 1320.44,
      Delta: -479.56,
      DeltaPercent: -26.6,
      Scope: 'Dedicated',
      Farms: ['48'],
      Regions: ['norwayeast'],
      Environment: 'Prod',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: false,
    },
    {
      Tenant: '(Shared)',
      Cost: 4200.0,
      LastPeriodCost: 6100.0,
      AllocatedSharedCost: 0,
      TotalCost: 4200.0,
      Delta: -1900.0,
      DeltaPercent: -31.1,
      Scope: 'FarmShared',
      Farms: [],
      Regions: [],
      Environment: '',
      IsPlatform: false,
      IsShared: true,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: true,
    },
    {
      Tenant: '(Platform)',
      Cost: 3100.0,
      LastPeriodCost: 4200.0,
      AllocatedSharedCost: 0,
      TotalCost: 3100.0,
      Delta: -1100.0,
      DeltaPercent: -26.2,
      Scope: 'Platform',
      Farms: [],
      Regions: [],
      Environment: '',
      IsPlatform: true,
      IsShared: false,
      IsManagement: false,
      IsUnknown: false,
      IsVirtual: true,
    },
    {
      Tenant: '(Management)',
      Cost: 980.0,
      LastPeriodCost: 1400.0,
      AllocatedSharedCost: 0,
      TotalCost: 980.0,
      Delta: -420.0,
      DeltaPercent: -30.0,
      Scope: 'Management',
      Farms: [],
      Regions: [],
      Environment: '',
      IsPlatform: false,
      IsShared: false,
      IsManagement: true,
      IsUnknown: false,
      IsVirtual: true,
    },
    {
      Tenant: '(Unknown)',
      Cost: 41962.96,
      LastPeriodCost: 95000.0,
      AllocatedSharedCost: 0,
      TotalCost: 41962.96,
      Delta: -53037.04,
      DeltaPercent: -55.8,
      Scope: 'Unknown',
      Farms: [],
      Regions: [],
      Environment: '',
      IsPlatform: false,
      IsShared: false,
      IsManagement: false,
      IsUnknown: true,
      IsVirtual: true,
    },
  ],

  ScopeSummary: [
    { Scope: 'Dedicated', Layer: 'Hosting', Cost: 21988.39, Percent: 38.1 },
    { Scope: 'PlanShared', Layer: 'Hosting', Cost: 3980.33, Percent: 6.9 },
    {
      Scope: 'FarmShared',
      Layer: 'Infrastructure',
      Cost: 4200.0,
      Percent: 7.3,
    },
    { Scope: 'RegionalShared', Layer: 'Network', Cost: 1820.0, Percent: 3.2 },
    { Scope: 'Platform', Layer: 'Monitoring', Cost: 3100.0, Percent: 5.4 },
    { Scope: 'Management', Layer: 'Operations', Cost: 980.0, Percent: 1.7 },
    { Scope: 'Unknown', Layer: 'Unknown', Cost: 41962.96, Percent: 37.4 },
  ],

  FarmSummary: [
    {
      FarmId: '48',
      Dedicated: 14600.0,
      PlanShared: 0,
      FarmShared: 1800.0,
      Total: 16400.0,
      Environment: 'Prod',
      Tenants: [
        'equinor',
        'technipfmc',
        'archer',
        'aker-bp',
        'online58cc36ff_pool_1',
      ],
    },
    {
      FarmId: '50',
      Dedicated: 7330.24,
      PlanShared: 0,
      FarmShared: 1200.0,
      Total: 8530.24,
      Environment: 'Prod',
      Tenants: ['nov', 'technipfmc', 'equinor'],
    },
    {
      FarmId: '189',
      Dedicated: 0,
      PlanShared: 2100.33,
      FarmShared: 600.0,
      Total: 2700.33,
      Environment: 'Dev',
      Tenants: ['halliburton'],
    },
    {
      FarmId: '190',
      Dedicated: 0,
      PlanShared: 1880.0,
      FarmShared: 600.0,
      Total: 2480.0,
      Environment: 'Dev',
      Tenants: ['schlumberger'],
    },
  ],

  ServiceTypeSummary: [
    { ServiceType: 'WebApp', Scope: 'Dedicated', Cost: 12400.0 },
    { ServiceType: 'AppServicePlan', Scope: 'PlanShared', Cost: 3980.33 },
    { ServiceType: 'SqlDatabase', Scope: 'Dedicated', Cost: 8200.0 },
    { ServiceType: 'VirtualMachine', Scope: 'FarmShared', Cost: 3100.0 },
    { ServiceType: 'AppInsights', Scope: 'Platform', Cost: 2200.0 },
    { ServiceType: 'Storage', Scope: 'RegionalShared', Cost: 1820.0 },
    { ServiceType: 'KeyVault', Scope: 'Dedicated', Cost: 1388.39 },
    { ServiceType: 'Redis', Scope: 'Dedicated', Cost: 980.0 },
    { ServiceType: 'SearchService', Scope: 'RegionalShared', Cost: 740.0 },
    { ServiceType: 'Unknown', Scope: 'Unknown', Cost: 41962.96 },
  ],

  Trend: [
    ...(
      [
        '2026-03-01',
        '2026-03-02',
        '2026-03-03',
        '2026-03-04',
        '2026-03-05',
        '2026-03-06',
        '2026-03-07',
        '2026-03-08',
        '2026-03-09',
      ] as const
    ).flatMap((date) => [
      {
        Date: date,
        GroupKey: 'Scope',
        GroupValue: 'Dedicated',
        Cost: 2200 + Math.random() * 800,
      },
      {
        Date: date,
        GroupKey: 'Scope',
        GroupValue: 'PlanShared',
        Cost: 400 + Math.random() * 200,
      },
      {
        Date: date,
        GroupKey: 'Scope',
        GroupValue: 'FarmShared',
        Cost: 450 + Math.random() * 150,
      },
      {
        Date: date,
        GroupKey: 'Scope',
        GroupValue: 'RegionalShared',
        Cost: 190 + Math.random() * 80,
      },
      {
        Date: date,
        GroupKey: 'Scope',
        GroupValue: 'Platform',
        Cost: 320 + Math.random() * 100,
      },
      {
        Date: date,
        GroupKey: 'Scope',
        GroupValue: 'Management',
        Cost: 100 + Math.random() * 50,
      },
    ]),
  ],

  Breakdown: [
    {
      ResourceId:
        '/subscriptions/ac1e/resourceGroups/rg-unknown-1/providers/Microsoft.Web/sites/myapp',
      ResourceName: 'myapp',
      ResourceGroup: 'rg-unknown-1',
      ResourceType: 'Microsoft.Web/sites',
      Tenant: '',
      Scope: 'Unknown',
      Farm: '',
      PlanGroup: '',
      Region: 'norwayeast',
      Environment: '',
      Layer: '',
      ServiceDomain: '',
      ServiceType: 'WebApp',
      ManagedBy: 'BulkTagEngine',
      TagVersion: 'v3',
      Ownership: '',
      ReviewRequired: 'Yes',
      ReviewReason: 'NoRuleMatchedRg:rg-unknown-1',
      Date: '',
      Cost: 18400.0,
    },
    {
      ResourceId:
        '/subscriptions/ac1e/resourceGroups/rg-purplesector/providers/Microsoft.Sql/servers/db1',
      ResourceName: 'db1',
      ResourceGroup: 'rg-purplesector',
      ResourceType: 'Microsoft.Sql/servers',
      Tenant: '',
      Scope: 'Unknown',
      Farm: '',
      PlanGroup: '',
      Region: 'norwayeast',
      Environment: '',
      Layer: '',
      ServiceDomain: '',
      ServiceType: 'SqlDatabase',
      ManagedBy: 'BulkTagEngine',
      TagVersion: 'v3',
      Ownership: '',
      ReviewRequired: 'Yes',
      ReviewReason: 'NoRuleMatchedRg:rg-purplesector',
      Date: '',
      Cost: 12200.0,
    },
    {
      ResourceId:
        '/subscriptions/2a1c/resourceGroups/rg-rag-test/providers/Microsoft.Web/sites/ragapp',
      ResourceName: 'ragapp',
      ResourceGroup: 'rg-rag-test',
      ResourceType: 'Microsoft.Web/sites',
      Tenant: '',
      Scope: 'Unknown',
      Farm: '',
      PlanGroup: '',
      Region: 'norwayeast',
      Environment: '',
      Layer: '',
      ServiceDomain: '',
      ServiceType: 'WebApp',
      ManagedBy: 'BulkTagEngine',
      TagVersion: 'v3',
      Ownership: '',
      ReviewRequired: 'Yes',
      ReviewReason: 'TenantExtractionFailed-DbRg',
      Date: '',
      Cost: 7842.96,
    },
    {
      ResourceId:
        '/subscriptions/ac1e/resourceGroups/rg-spike-env/providers/Microsoft.Compute/virtualMachines/vm1',
      ResourceName: 'vm1',
      ResourceGroup: 'rg-spike-env',
      ResourceType: 'Microsoft.Compute/virtualMachines',
      Tenant: '',
      Scope: 'Unknown',
      Farm: '',
      PlanGroup: '',
      Region: 'westeurope',
      Environment: '',
      Layer: '',
      ServiceDomain: '',
      ServiceType: 'VirtualMachine',
      ManagedBy: 'BulkTagEngine',
      TagVersion: 'v3',
      Ownership: '',
      ReviewRequired: 'Yes',
      ReviewReason: 'NoRuleMatchedRg:rg-spike-env',
      Date: '',
      Cost: 3520.0,
  ],
};
*/

// ─────────────────────────────────────────────────────────────────────────────

class CostService {
  async GetCostSummary(filter: CostFilterDto): Promise<CostSummaryDto> {
    return callService('cost', 'summary', RequestType.POST, filter);
  }

  /**
   * Triggers a browser download for a specific tenant's detailed CSV report.
   */
  async exportTenantCsv(
    tenant: string,
    from: string,
    to: string,
  ): Promise<void> {
    const url = `/api/cost/export/tenant?tenant=${encodeURIComponent(tenant)}&from=${from}&to=${to}`;
    window.open(url, '_blank');
  }

  /**
   * Triggers a browser download for the master summary CSV of all tenants.
   */
  async exportAllTenantsCsv(from: string, to: string): Promise<void> {
    const url = `/api/cost/export/tenants?from=${from}&to=${to}`;
    window.open(url, '_blank');
  }
  /**
   * Fetches the granular resource-level breakdown for a specific tenant on-demand.
   */
  async getTenantBreakdown(
    tenantId: string,
    from: string,
    to: string,
  ): Promise<CostBreakdownRow[]> {
    const url = `breakdown/tenant?tenantId=${encodeURIComponent(tenantId)}&from=${from}&to=${to}`;
    return callService('cost', url, RequestType.GET);
  }

  /**
   * Fetches the granular resource-level breakdown for a specific service type on-demand.
   */
  async getServiceBreakdown(
    serviceType: string,
    from: string,
    to: string,
  ): Promise<CostBreakdownRow[]> {
    const url = `breakdown/service?serviceType=${encodeURIComponent(serviceType)}&from=${from}&to=${to}`;
    return callService('cost', url, RequestType.GET);
  }

  /**
   * Triggers a full data clear and re-ingestion (backfill) for the specified number of days.
   */
  async refreshData(
    days: number = 60,
  ): Promise<{ message: string; jobId: string }> {
    return callService('cost', `refresh?days=${days}`, RequestType.POST);
  }
}

export const costService: CostService = new CostService();
export const exportAllTenantsCsv = (from: string, to: string) =>
  costService.exportAllTenantsCsv(from, to);
export const exportTenantCsv = (tenant: string, from: string, to: string) =>
  costService.exportTenantCsv(tenant, from, to);
export const getTenantBreakdown = (
  tenantId: string,
  from: string,
  to: string,
) => costService.getTenantBreakdown(tenantId, from, to);
export const refreshData = (days: number = 60) => costService.refreshData(days);
